export default __webpack_public_path__ + "static/media/bak.186c29cf.png";